// Route pattern parts
export const WILDCARD = '{/*path}'
export const ID_PARAM = '/:id'

// Helper to build pattern with wildcard
export const withWildcard = (segment: string) => `${segment}${WILDCARD}`

// Helper to build pattern with id and wildcard
export const withIdWildcard = (segment: string) =>
  `${segment}${ID_PARAM}${WILDCARD}`
